// extracted by mini-css-extract-plugin
export default {"container":"styles_container__eEu5Q","content":"styles_content__4qxBN","slide":"styles_slide__VsaVZ","image":"styles_image__ogXtE"};